
<div class="white-bg no-padding no-margin">
  <!-- <breadcrumbs>
    <breadcrumb route="/" label="Dashboard"></breadcrumb>
    <breadcrumb [currentRoute]="true" label="Setup Training Types and Section"></breadcrumb>
  </breadcrumbs> -->


<mat-card>
  <div style="text-align: center;">
    <span class="title-header">Setup Training Types and Sub Types</span>
  </div>
  <ng-container *ngFor="let fcm of trainingMainCategories">
    <div style="margin: 24px 0px;">
      <div style="display: flex;">
        <h3 title="fcm.TrainigCatName"><b><u></u></b></h3>
        <div style="float: right;cursor: pointer;" >
          <i *ngIf="fcm.Active" style="color: green;" class="material-icons sc-icon" (click)="toggleMainCategoryActive(fcm.TrainigCatId, false)">done</i>
       
          <i *ngIf="!fcm.Active"style="color: red;" class="material-icons sc-icon" (click)="toggleMainCategoryActive(fcm.TrainigCatId, true)">cancel</i>
        </div>
        <span style="font-size: large; "><b><u>{{fcm.TrainigCatName  | translate | async}}</u></b></span>
        <!-- <i *ngIf="fc.QCategoryName!='Default Category'" class="material-icons sc-icon" style="align-self: center;"  (click)="OpenEditCategory(fc.FormId,fc.QuestionCatId,true,fc.QCategoryName)">edit</i> -->
        <i  class="material-icons sc-icon" style="align-self: center;cursor: pointer;"  (click)="OpenEditMainCategory(fcm.TrainigCatId,fcm.TrainigCatName)">edit</i>

        <ng-container >
          
           
          <ng-container *ngIf="fcm.Order == 0 && trainingMainCategories.length !=1">
            <i style="font-size:30px;cursor: pointer;" class="material-icons sc-icon" (click)="OrderDown_MC(fcm.Order)">arrow_drop_down</i>
          </ng-container>

          <ng-container *ngIf="fcm.Order != 0 ">
           
            <ng-container *ngIf="fcm.Order == trainingMainCategories.length - 1 ">
              <i style="font-size:30px;cursor: pointer;" class="material-icons sc-icon" (click)="OrderUP_MC(fcm.Order)">arrow_drop_up</i> 
            </ng-container>
            

            <ng-container *ngIf="fcm.Order != trainingMainCategories.length - 1 && trainingMainCategories.length != 2">
              <i style="font-size:30px;cursor: pointer;" class="material-icons sc-icon" (click)="OrderDown_MC(fcm.Order)">arrow_drop_down</i>
              <i style="font-size:30px;cursor: pointer;" class="material-icons sc-icon" (click)="OrderUP_MC(fcm.Order)">arrow_drop_up</i> 
            </ng-container>

          </ng-container>

         

        </ng-container>
      </div>

      <ng-container  *ngFor="let fc of trainingCategories">
        <ng-container *ngIf=" fc.MainParentId && fc.MainParentId == fcm.TrainigCatId">

       
        <div style="margin: 24px 0px;">
          <div style="display: flex;margin-left: 2%;">
              <h3 title="fc.TrainigCatName"><b><u></u></b></h3>
              <div style="float: right;cursor: pointer;" >
                            
                <i *ngIf="fc.Active" style="color: green;" class="material-icons sc-icon" (click)="toggleCategoryActive(fc.TrainigCatId, false)">done</i>
           
                <i *ngIf="!fc.Active"style="color: red;" class="material-icons sc-icon" (click)="toggleCategoryActive(fc.TrainigCatId, true)">cancel</i>
            
            </div>
              <span style="font-size: large; "><b><u>{{fc.TrainigCatName  | translate | async}}</u></b></span>
              <!-- <i *ngIf="fc.QCategoryName!='Default Category'" class="material-icons sc-icon" style="align-self: center;"  (click)="OpenEditCategory(fc.FormId,fc.QuestionCatId,true,fc.QCategoryName)">edit</i> -->
              <i  class="material-icons sc-icon" style="align-self: center;cursor: pointer;"  (click)="OpenEditCategory(fc.TrainigCatId,true,fc.TrainigCatName)">edit</i>
              <!-- <ng-container >
              
               
                <ng-container *ngIf="fc.Order == 0 && trainingCategories.length !=1">
                  <i style="font-size:30px;cursor: pointer;" class="material-icons sc-icon" (click)="OrderDown_C(fc.Order,fc.MainParentId)">arrow_drop_down</i>
                </ng-container>
      
                <ng-container *ngIf="fc.Order != 0 ">
                 
                  <ng-container *ngIf="fc.Order == trainingCategories.length - 1 ">
                    <i style="font-size:30px;cursor: pointer;" class="material-icons sc-icon" (click)="OrderUP_C(fc.Order,fc.MainParentId)">arrow_drop_up</i> 
                  </ng-container>
                  
      
                  <ng-container *ngIf="fc.Order != trainingCategories.length - 1 && trainingCategories.length != 2">
                    <i style="font-size:30px;cursor: pointer;" class="material-icons sc-icon" (click)="OrderDown_C(fc.Order,fc.MainParentId)">arrow_drop_down</i>
                    <i style="font-size:30px;cursor: pointer;" class="material-icons sc-icon" (click)="OrderUP_C(fc.Order,fc.MainParentId)">arrow_drop_up</i> 
                  </ng-container>
      
                </ng-container>
      
               
      
              </ng-container> -->


              <ng-container > 
                <ng-container *ngIf="fc.Order == 0 && fcm.SectionCount >1">
                  <i style="font-size:30px;cursor: pointer;" class="material-icons sc-icon" (click)="OrderDown_C(fc.Order,fc.MainParentId)">arrow_drop_down</i> 
                </ng-container>
                    
                <ng-container *ngIf="fcm.SectionCount != 1 && fc.Order != 0">
                  <ng-container *ngIf="fc.Order == fcm.SectionCount - 1">
                  <i style="font-size:30px;cursor: pointer;" class="material-icons sc-icon" (click)="OrderUP_C(fc.Order,fc.MainParentId)">arrow_drop_up</i> 
                  </ng-container>
              
                  <ng-container *ngIf="fc.Order != fcm.SectionCount - 1">
                    <i style="font-size:30px;cursor: pointer;" class="material-icons sc-icon" (click)="OrderDown_C(fc.Order,fc.MainParentId)">arrow_drop_down</i>
                    <i style="font-size:30px;cursor: pointer;" class="material-icons sc-icon" (click)="OrderUP_C(fc.Order,fc.MainParentId)">arrow_drop_up</i> 
                    </ng-container>
                </ng-container>
              
               
              </ng-container>
          </div>
    
    
          <ng-container *ngFor="let fs of trainingSections">
            <ng-container *ngIf=" fs.ParentCatId && fs.ParentCatId == fc.TrainigCatId">
              <div style="display: flex;margin-left: 5%;" >
          
                <div style="float: right;cursor: pointer;" >
                                  
                  <i *ngIf="fs.Active" style="color: green;" class="material-icons sc-icon" (click)="toggleCategoryActive(fs.TrainigCatId, false)">done</i>
             
                  <i *ngIf="!fs.Active"style="color: red;" class="material-icons sc-icon" (click)="toggleCategoryActive(fs.TrainigCatId, true)">cancel</i>
              
              </div>
                <span style="font-size: larger; "><b><u>{{fs.TrainigCatName  | translate | async}}</u></b></span>
                <!-- <i *ngIf="fs.QCategoryName!='Default Section'" class="material-icons sc-icon" style="align-self: center;"  (click)="OpenEditCategory(fc.FormId,fs.QuestionCatId,false,fs.QCategoryName)">edit</i> -->
                <i  class="material-icons sc-icon" style="align-self: center;cursor: pointer;"  (click)="OpenEditCategory(fs.TrainigCatId,false,fs.TrainigCatName)">edit</i>
                  
          
                  <ng-container > 
                    <ng-container *ngIf="fs.Order == 0 && fc.SectionCount >1">
                      <i style="font-size:30px;cursor: pointer;" class="material-icons sc-icon" (click)="OrderDown_S(fs.Order,fs.ParentCatId)">arrow_drop_down</i> 
                    </ng-container>
                        
                    <ng-container *ngIf="fc.SectionCount != 1 && fs.Order != 0">
                      <ng-container *ngIf="fs.Order == fc.SectionCount - 1">
                      <i style="font-size:30px;cursor: pointer;" class="material-icons sc-icon" (click)="OrderUP_S(fs.Order,fs.ParentCatId)">arrow_drop_up</i> 
                      </ng-container>
                  
                      <ng-container *ngIf="fs.Order != fc.SectionCount - 1">
                        <i style="font-size:30px;cursor: pointer;" class="material-icons sc-icon" (click)="OrderDown_S(fs.Order,fs.ParentCatId)">arrow_drop_down</i>
                        <i style="font-size:30px;cursor: pointer;" class="material-icons sc-icon" (click)="OrderUP_S(fs.Order,fs.ParentCatId)">arrow_drop_up</i> 
                        </ng-container>
                    </ng-container>
                  
                   
                  </ng-container>
                 
          
                
              
                   
               </div>
            
    
               <ng-container *ngFor="let f of trainings">
                <ng-container *ngIf=" fs.TrainigCatId == f.TrainingTypeId">
                  <div style="display: flex;margin-left: 10%;" >
              
                    <div style="float: right;cursor: pointer;" >
                                      
                      <i *ngIf="f.Active" style="color: green;" class="material-icons sc-icon" (click)="toggleTrainingActive(f.TrainingId, false)">done</i>
                 
                      <i *ngIf="!f.Active"style="color: red;" class="material-icons sc-icon" (click)="toggleTrainingActive(f.TrainingId, true)">cancel</i>
                  
                  </div>
                    <span style="font-size: larger; "><b><u>{{f.TrainingName  | translate | async}}</u></b></span>
                    <!-- <i *ngIf="fs.QCategoryName!='Default Section'" class="material-icons sc-icon" style="align-self: center;"  (click)="OpenEditCategory(fc.FormId,fs.QuestionCatId,false,fs.QCategoryName)">edit</i> -->
                    <i  class="material-icons sc-icon" style="align-self: center;cursor: pointer;"  (click)="OpenEditTraining(f.TrainingId,false,f.TrainingName)">edit</i>
                      
              
                      <ng-container > 
                        <ng-container *ngIf="f.Order == 0 && fs.TrainingCount >1">
                          <i style="font-size:30px;cursor: pointer;" class="material-icons sc-icon" (click)="OrderDown_T(f.Order,f.TrainingTypeId)">arrow_drop_down</i> 
                        </ng-container>
                            
                        <ng-container *ngIf="fs.TrainingCount != 1 && f.Order != 0">
                          <ng-container *ngIf="f.Order == fs.TrainingCount - 1">
                          <i style="font-size:30px;cursor: pointer;" class="material-icons sc-icon" (click)="OrderUP_T(f.Order,f.TrainingTypeId)">arrow_drop_up</i> 
                          </ng-container>
                      
                          <ng-container *ngIf="f.Order != fs.TrainingCount - 1">
                            <i style="font-size:30px;cursor: pointer;" class="material-icons sc-icon" (click)="OrderDown_T(f.Order,f.TrainingTypeId)">arrow_drop_down</i>
                            <i style="font-size:30px;cursor: pointer;" class="material-icons sc-icon" (click)="OrderUP_T(f.Order,f.TrainingTypeId)">arrow_drop_up</i> 
                            </ng-container>
                        </ng-container>
                      
                       
                      </ng-container>
                     
              
                    
                  
                       
                   </div>
                
                   <div style="width: 100%;">
                   
                </div>
                 
                </ng-container>
                
              </ng-container>
    
               <div style="width: 100%;">
                <a class="button button--primary" style="margin-bottom: 16px;margin-left: 10%; " (click)="OpenAddTraining(fs.TrainigCatId)" >
                  <span class="button__text">{{'Add Training' | translate | async}}</span></a>
            </div>
             
            </ng-container>
            
          </ng-container>
        <div style="width: 100%;">
                  <a class="button button--primary" style="margin-bottom: 16px;margin-left: 5%; " (click)="OpenAddSection(fc.TrainigCatId)" >
                    <span class="button__text">{{'Add Sub Category' | translate | async}}</span></a>
        </div>
    
      </div>
    </ng-container>
      </ng-container>
      <div style="width: 100%;margin-left: 2%;">
        <a class="button button--primary"   (click)="OpenAddCategory(fcm.TrainigCatId)" >
          <span class="button__text">{{'Add Category'  | translate | async}}</span></a>
      </div>
      </div>
  </ng-container>
  <!-- <ng-container  *ngFor="let fc of trainingCategories">
    <div style="margin: 24px 0px;">
      <div style="display: flex;">
          <h3 title="fc.TrainigCatName"><b><u></u></b></h3>
          <div style="float: right;cursor: pointer;" >
                        
            <i *ngIf="fc.Active" style="color: green;" class="material-icons sc-icon" (click)="toggleCategoryActive(fc.TrainigCatId, false)">done</i>
       
            <i *ngIf="!fc.Active"style="color: red;" class="material-icons sc-icon" (click)="toggleCategoryActive(fc.TrainigCatId, true)">cancel</i>
        
        </div>
          <span style="font-size: large; "><b><u>{{fc.TrainigCatName  | translate | async}}</u></b></span>
        
          <i  class="material-icons sc-icon" style="align-self: center;cursor: pointer;"  (click)="OpenEditCategory(fc.TrainigCatId,true,fc.TrainigCatName)">edit</i>
          <ng-container >
          
           
            <ng-container *ngIf="fc.Order == 0 && trainingCategories.length !=1">
              <i style="font-size:30px;cursor: pointer;" class="material-icons sc-icon" (click)="OrderDown_C(fc.Order)">arrow_drop_down</i>
            </ng-container>
  
            <ng-container *ngIf="fc.Order != 0 ">
             
              <ng-container *ngIf="fc.Order == trainingCategories.length - 1 ">
                <i style="font-size:30px;cursor: pointer;" class="material-icons sc-icon" (click)="OrderUP_C(fc.Order)">arrow_drop_up</i> 
              </ng-container>
              
  
              <ng-container *ngIf="fc.Order != trainingCategories.length - 1 && trainingCategories.length != 2">
                <i style="font-size:30px;cursor: pointer;" class="material-icons sc-icon" (click)="OrderDown_C(fc.Order)">arrow_drop_down</i>
                <i style="font-size:30px;cursor: pointer;" class="material-icons sc-icon" (click)="OrderUP_C(fc.Order)">arrow_drop_up</i> 
              </ng-container>
  
            </ng-container>
  
           
  
          </ng-container>
      </div>


      <ng-container *ngFor="let fs of trainingSections">
        <ng-container *ngIf=" fs.ParentCatId && fs.ParentCatId == fc.TrainigCatId">
          <div style="display: flex;margin-left: 5%;" >
      
            <div style="float: right;cursor: pointer;" >
                              
              <i *ngIf="fs.Active" style="color: green;" class="material-icons sc-icon" (click)="toggleCategoryActive(fs.TrainigCatId, false)">done</i>
         
              <i *ngIf="!fs.Active"style="color: red;" class="material-icons sc-icon" (click)="toggleCategoryActive(fs.TrainigCatId, true)">cancel</i>
          
          </div>
            <span style="font-size: larger; "><b><u>{{fs.TrainigCatName  | translate | async}}</u></b></span>
           
            <i  class="material-icons sc-icon" style="align-self: center;cursor: pointer;"  (click)="OpenEditCategory(fs.TrainigCatId,false,fs.TrainigCatName)">edit</i>
              
      
              <ng-container > 
                <ng-container *ngIf="fs.Order == 0 && fc.SectionCount >1">
                  <i style="font-size:30px;cursor: pointer;" class="material-icons sc-icon" (click)="OrderDown_S(fs.Order,fs.ParentCatId)">arrow_drop_down</i> 
                </ng-container>
                    
                <ng-container *ngIf="fc.SectionCount != 1 && fs.Order != 0">
                  <ng-container *ngIf="fs.Order == fc.SectionCount - 1">
                  <i style="font-size:30px;cursor: pointer;" class="material-icons sc-icon" (click)="OrderUP_S(fs.Order,fs.ParentCatId)">arrow_drop_up</i> 
                  </ng-container>
              
                  <ng-container *ngIf="fs.Order != fc.SectionCount - 1">
                    <i style="font-size:30px;cursor: pointer;" class="material-icons sc-icon" (click)="OrderDown_S(fs.Order,fs.ParentCatId)">arrow_drop_down</i>
                    <i style="font-size:30px;cursor: pointer;" class="material-icons sc-icon" (click)="OrderUP_S(fs.Order,fs.ParentCatId)">arrow_drop_up</i> 
                    </ng-container>
                </ng-container>
              
               
              </ng-container>
             
      
            
          
               
           </div>
        

           <ng-container *ngFor="let f of trainings">
            <ng-container *ngIf=" fs.TrainigCatId == f.TrainingTypeId">
              <div style="display: flex;margin-left: 10%;" >
          
                <div style="float: right;cursor: pointer;" >
                                  
                  <i *ngIf="fs.Active" style="color: green;" class="material-icons sc-icon" (click)="toggleTrainingActive(f.TrainingId, false)">done</i>
             
                  <i *ngIf="!fs.Active"style="color: red;" class="material-icons sc-icon" (click)="toggleCategoryActive(f.TrainingId, true)">cancel</i>
              
              </div>
                <span style="font-size: larger; "><b><u>{{f.TrainingName  | translate | async}}</u></b></span>
              
                <i  class="material-icons sc-icon" style="align-self: center;cursor: pointer;"  (click)="OpenEditTraining(f.TrainingId,false,f.TrainingName)">edit</i>
                  
          
                  <ng-container > 
                    <ng-container *ngIf="f.Order == 0 && fs.TrainingCount >1">
                      <i style="font-size:30px;cursor: pointer;" class="material-icons sc-icon" (click)="OrderDown_T(f.Order,f.TrainingTypeId)">arrow_drop_down</i> 
                    </ng-container>
                        
                    <ng-container *ngIf="fs.TrainingCount != 1 && f.Order != 0">
                      <ng-container *ngIf="f.Order == fs.TrainingCount - 1">
                      <i style="font-size:30px;cursor: pointer;" class="material-icons sc-icon" (click)="OrderUP_T(f.Order,f.TrainingTypeId)">arrow_drop_up</i> 
                      </ng-container>
                  
                      <ng-container *ngIf="f.Order != fs.TrainingCount - 1">
                        <i style="font-size:30px;cursor: pointer;" class="material-icons sc-icon" (click)="OrderDown_T(f.Order,f.TrainingTypeId)">arrow_drop_down</i>
                        <i style="font-size:30px;cursor: pointer;" class="material-icons sc-icon" (click)="OrderUP_T(f.Order,f.TrainingTypeId)">arrow_drop_up</i> 
                        </ng-container>
                    </ng-container>
                  
                   
                  </ng-container>
                 
          
                
              
                   
               </div>
            
               <div style="width: 100%;">
               
            </div>
             
            </ng-container>
            
          </ng-container>

           <div style="width: 100%;">
            <a class="button button--primary" style="margin-bottom: 16px;margin-left: 10%; " (click)="OpenAddTraining(fs.TrainigCatId)" >
              <span class="button__text">{{'Add Training' | translate | async}}</span></a>
        </div>
         
        </ng-container>
        
      </ng-container>
    <div style="width: 100%;">
              <a class="button button--primary" style="margin-bottom: 16px;margin-left: 5%; " (click)="OpenAddSection(fc.TrainigCatId)" >
                <span class="button__text">{{'Add Sub Category' | translate | async}}</span></a>
    </div>

  </div>
  </ng-container> -->
  <div style="width: 100%;">
    <a class="button button--primary"   (click)="OpenAddMainCategory()" >
      <span class="button__text">{{'Add Main Category'  | translate | async}}</span></a>
  </div>
</mat-card>
</div>